var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'form__label',
    _vm.status === 'invalid' ? 'form__label--invalid' : false,
    _vm.active ? 'form__label--focus' : false ],attrs:{"for":_vm.params.id,"aria-labelledby":_vm.params.id,"aria-label":_vm.params.label}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.params.label)}}),(_vm.params.required)?_c('span',{class:['form__required'],domProps:{"innerHTML":_vm._s('(*)')}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }